import * as React from 'react';
import styles from './index.less';

export interface FTextBtnProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  children: React.ReactNode;
  type?: 'primary' | 'default' | 'danger';
  /**
   * default — Figma「文字按钮1」：min-height 38、padding 9×15、hover/active 浅底；
   * compact — Figma「文字按钮2」：hug 内容、hover/active 降低整钮不透明度。
   */
  size?: 'default' | 'compact';
  className?: string;
  /** 原生 button 的 type 属性；默认 button，避免置于表单内被当成 submit */
  buttonType?: 'button' | 'submit' | 'reset';
}

function FTextBtn({
  children,
  type = 'primary',
  size = 'compact',
  className,
  style,
  disabled,
  onClick,
  buttonType = 'button',
  ...rest
}: FTextBtnProps) {
  return (
    <button
      type={buttonType}
      className={[
        styles.textBtn,
        size === 'default' ? styles.sizeDefault : styles.sizeCompact,
        styles[type],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={style}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}

export default FTextBtn;
